import * as React from 'react';

import * as styles from './styles.css';

interface IOfferHistoryProps {
  fullscreenViewBtn?: React.ReactElement<any>;
  fullscreenView: React.ReactElement<any>;
  offersTableSmall: React.ReactElement<any>;
}

export const OfferHistory: React.FC<IOfferHistoryProps> = ({ offersTableSmall, fullscreenViewBtn, fullscreenView }) => {
  return (
    <div className={styles['container']}>
      {offersTableSmall}
      {fullscreenViewBtn}
      {fullscreenView}
    </div>
  );
};
